

import React from "react";

const TopSuppliers = () => {

    const suppliers = [

        {
            name: "ABC Engineering",
            otif: 98,
            quality: 96,
            rating: 5
        },

        {
            name: "XYZ Industries",
            otif: 94,
            quality: 93,
            rating: 4
        },

        {
            name: "PQR Solutions",
            otif: 88,
            quality: 90,
            rating: 4
        },

        {
            name: "LMN Traders",
            otif: 82,
            quality: 85,
            rating: 3
        }

    ];

    return (

        <div className="table-responsive">

            <table className="table align-middle supplierTable">

                <thead>

                    <tr>
                        <th>Supplier</th>
                        <th>OTIF</th>
                        <th>Quality</th>
                        <th>Rating</th>
                    </tr>

                </thead>

                <tbody>

                    {

                        suppliers.map((item, index) => (

                            <tr key={index}>

                                <td>
                                    <strong>{item.name}</strong>
                                </td>

                                <td>

                                    <span className="badge bg-success">
                                        {item.otif}%
                                    </span>

                                </td>

                                <td>

                                    <span className="badge bg-primary">
                                        {item.quality}%
                                    </span>

                                </td>

                                <td>

                                    <span
                                        style={{
                                            color: "#F59E0B",
                                            fontSize: "18px"
                                        }}
                                    >
                                        {"★".repeat(item.rating)}
                                        {"☆".repeat(5 - item.rating)}
                                    </span>

                                </td>

                            </tr>

                        ))

                    }

                </tbody>

            </table>

        </div>

    );

};

export default TopSuppliers;